export default __webpack_public_path__ + "static/media/clamp.f0534bd0.png";